import React, {useEffect, useState} from "react";
import CategoryContainer from "../category-container/category-container";
import SubCategoriesContainer from "../sub-categories-container/subCategoriesContainer";
import {coralsV2 as categories} from "../../../services/api/data/coral-types-v2";
// import styles from "../category-container/category_container.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleDown, faAngleUp} from "@fortawesome/free-solid-svg-icons";
import SubCategoryContainer from "../v3/subcategory/subCategoryContainer";

import styles from './megaMenuvV2.module.css'

const MOBILE_BREAKPOINT = 768;

const MegaMenuV2: React.FC = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [activeCategory, setActiveCategory] = useState<string | null>(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);
    const [openMobileCats, setOpenMobileCats] = useState<string[]>([]);
    const [leaveTimeout, setLeaveTimeout] = useState(null);


    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
            if (leaveTimeout) {
                clearTimeout(leaveTimeout);
            }
        };
    }, [leaveTimeout]);

    const handleCategoryHover = (category: string) => {
        if (!isMobile) setActiveCategory(category);
    };

    const handleCategoryClick = (category: string) => {
        if (isMobile) {
            setOpenMobileCats(prev =>
                prev.includes(category)
                    ? prev.filter(c => c !== category)
                    : [...prev, category]
            );
        }
    };

    const handleSubcategoryClick = (e: React.MouseEvent, url: string) => {
        e.preventDefault();
        window.location.href = url;
    };

    // const handleMouseEnter = () => {
    //     if (!isMobile) {
    //         setIsMenuOpen(true);
    //         setActiveCategory(categories[0].name);
    //     }
    // };

    const handleMouseEnter = () => {
        if (!isMobile) {
            if (leaveTimeout) {
                clearTimeout(leaveTimeout);
                setLeaveTimeout(null);
            }
            setIsMenuOpen(true);
            setActiveCategory(categories[0].name);
        }
    };

    const handleClick = (e: React.MouseEvent) => {
        if (isMobile) {
            e.preventDefault();
            setIsMenuOpen(prev => !prev);
        }
    };

    const handleMouseLeave = () => {
        if (!isMobile) {
            const timeout = setTimeout(() => {
                setIsMenuOpen(false);
            }, 100); // adjust the delay as needed
            // @ts-ignore
            setLeaveTimeout(timeout);
        }
    };

    const handleArrowClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (isMobile) {
            e.preventDefault();
            setIsMenuOpen(prev => !prev);
        }
    }



    return (
        <div
            className={styles.dropDownContainer}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >

            <a
                className="nav-link dropdown-toggle"
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    window.location.href = `/corals/`;
                }}
            >
                <span>Corals</span>
                <FontAwesomeIcon
                    icon={isMenuOpen ? faAngleUp : faAngleDown}
                    style={{color: isMenuOpen ? 'royalblue' : 'white', marginLeft: '7px'}}
                    onClick={(e) => {
                        e.stopPropagation(); // IMPORTANT
                        handleClick(e);
                    }}
                />
            </a>

            {/* ---------- DESKTOP ---------- */}
            {isMenuOpen && (

                <div className={styles.dropdownContent}>
                    <div className={styles.categoryColumn}>
                        <CategoryContainer
                            categories={categories}
                            activeCategory={activeCategory}
                            handleCategoryClick={() => {
                            }}
                            handleCategoryHover={handleCategoryHover}
                            isMobile={false}
                        />
                    </div>

                    <div className={styles.subCategoryColumn}>
                        <SubCategoriesContainer
                            categories={categories}
                            activeCategory={activeCategory}
                            drillPath={null}
                            isMobile={false}
                            handleBack={() => {
                            }}
                        />
                    </div>
                </div>
            )}


            {/*/!* ---------- MOBILE ---------- *!/*/}
            {/*{isMenuOpen && isMobile && (*/}
            {/*    <div className="mega-mobile">*/}
            {/*        {categories.map(cat => (*/}
            {/*            <div key={cat.name}>*/}
            {/*                <div*/}
            {/*                    className="mobile-cat"*/}

            {/*                >*/}
            {/*                    /!*<div className={styles.categoryWrapper}>*!/*/}
            {/*                    <div className="categoryWrapper2">*/}
            {/*                        <a href={`/corals/${cat.name.toLowerCase()}`} className="ll">*/}
            {/*                            <img src={cat.imageUrl} alt={cat.name} className={styles.categoryImage}/>*/}
            {/*                            <span>{cat.name}</span>*/}
            {/*                        </a>*/}
            {/*                        <div className="arrowContainer" onClick={() => handleCategoryClick(cat.name)}>*/}
            {/*                            <FontAwesomeIcon*/}
            {/*                                icon={openMobileCats.includes(cat.name) ? faAngleUp : faAngleDown}*/}
            {/*                                style={{color: openMobileCats.includes(cat.name) ? '#16CFF9' : 'gray'}}*/}
            {/*                                // className={styles.icon}*/}
            {/*                            />*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}

            {/*                {openMobileCats.includes(cat.name) && (*/}
            {/*                    <div className="mobile-subs">*/}
            {/*                        {cat.subCategories?.map(sub => (*/}
            {/*                            <SubCategoryContainer*/}
            {/*                                categoryName={cat.name}*/}
            {/*                                subCategory={sub}*/}
            {/*                            />*/}
            {/*                        ))}*/}
            {/*                    </div>*/}
            {/*                )}*/}
            {/*            </div>*/}
            {/*        ))}*/}
            {/*    </div>*/}
            {/*)}*/}
        </div>
    );
};

export default MegaMenuV2;
